module.exports = __webpack_public_path__ + "montserrat-mediumitalic-webfont.f16ae2b801b5c6ccc201.woff2";


//////////////////
// WEBPACK FOOTER
// D:/Honda/Trunk/WizdomWebApp/Wizdom-Web-App/src/assets/fonts/montserrat-mediumitalic-webfont.woff2
// module id = ../../../../../src/assets/fonts/montserrat-mediumitalic-webfont.woff2
// module chunks = styles